require('@zalando-internal/z-shop-js-env');

exports.react = require('react');
exports['react-dom'] = require('react-dom');
exports['react-is'] = require('react-is');
exports['react-uid'] = require('react-uid');
exports['styled-components'] = require('styled-components');

exports['@zalando-internal/z-shop-event-bus'] = require('@zalando-internal/z-shop-event-bus');
exports['z-shop-event-bus'] = require('@zalando-internal/z-shop-event-bus');
exports['@zalando-internal/zalando-consent-api'] = require('@zalando-internal/zalando-consent-api');
exports['zalando-consent-api'] = require('@zalando-internal/zalando-consent-api');
exports['safe-fetch'] = require('./fetch-extension');
exports['@pegasus/rest-client'] = require('@pegasus/rest-client');
exports['@pegasus/tracker'] = require('@pegasus/tracker');
